/**
 * WaveScorePro i18n bootstrap.
 *
 * Strategy — reach without perfection:
 *   - English is the source of truth.
 *   - French is a full translation (target market for SN + CI).
 *   - Wolof and Hausa are headline / hero / CTA translations only, with
 *     English fallback for everything else. This is deliberate: we don't
 *     have native speakers on staff, and shipping bad translations of
 *     technical strings ("fingerprint match", "audit chain") would erode
 *     credibility. Ship where we're confident; fall back where we aren't.
 *   - Language stored in localStorage.wsp.lang; also honours the browser's
 *     Accept-Language.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import wo from "./locales/wo.json";
import ha from "./locales/ha.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English",  native: "English"  },
  { code: "fr", label: "French",   native: "Français" },
  { code: "wo", label: "Wolof",    native: "Wolof"    },
  { code: "ha", label: "Hausa",    native: "Hausa"    },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      wo: { translation: wo },
      ha: { translation: ha },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: "languageOnly",     // treat 'fr-FR' as 'fr'
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "wsp.lang",
      caches: ["localStorage"],
    },
    returnEmptyString: false, // empty string in a translation → fallback
  });

export default i18n;
